import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaCog } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import SearchBar from '../common/SearchBar';
import '../../styles/AdminNavbar.css';

const AdminNavbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState('');

  const adminDisplayName = (
    `${currentUser?.first_name || ''} ${currentUser?.last_name || ''}`.trim() || currentUser?.email || 'Admin'
  );
  
  const handleSearch = (query) => {
    if (query.trim()) {
      // You can customize the search route for admin as needed
      navigate(`/admin/search?q=${encodeURIComponent(query)}`);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="admin-navbar-content">
      <div className="admin-search-bar">
        <SearchBar 
          placeholder="Search..."
          value={searchQuery}
          onChange={setSearchQuery}
          onSubmit={handleSearch}
          size="sm"
          className="admin-search"
        />
      </div>

      <div className="admin-navbar-actions">
        <div className="user-menu" ref={dropdownRef}>
          <button onClick={() => setDropdownOpen(!dropdownOpen)} className="user-menu-btn">
            <FaUser />
            <span className="user-menu-name">{adminDisplayName}</span>
          </button>

          {dropdownOpen && (
            <div className="user-dropdown-menu">
              <div className="dropdown-header">
                Signed in as<br />
                <strong>{adminDisplayName}</strong>
              </div>
              <Link to="/profile" className="dropdown-item">
                <FaUser className="me-2" /> Profile
              </Link>
              <Link to="/settings" className="dropdown-item">
                <FaCog className="me-2" /> Settings
              </Link>
              <div className="dropdown-divider"></div>
              <button onClick={handleLogout} className="dropdown-item dropdown-item-btn">
                <FaSignOutAlt className="me-2" /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminNavbar;
